/* UserTrigger.tsx generated by @compiled/babel-plugin v0.40.0 */
// PLEASE NOTE: This file is sync-loaded with the trigger components. Only add components here that
// are necessary for the main render of the trigger component to help maintain bundle size.
/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression -- needs manual remediation */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1gwv%7Bwidth%3A360px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i16xz%7Bheight%3A6pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1h6o%7Bjustify-content%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswh2mm%7Bposition%3Arelative%7D");
import React, { type ReactNode } from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
const styles = {
  cardWrapper: "_1bsb1gwv",
  spinnerContainer: "_4cvr1h6o _1e0c1txw _4t3i16xz _1bah1h6o _kqswh2mm"
};
export const CardWrapper = ({
  children,
  role,
  testId,
  labelledBy,
  ariaLabel
}: {
  children: ReactNode;
  role?: string;
  testId?: string;
  labelledBy?: string;
  ariaLabel?: string;
}): React.JSX.Element => <Box xcss={cx(styles.cardWrapper)} backgroundColor={'elevation.surface.overlay'} role={role} testId={testId} aria-labelledby={labelledBy} aria-label={ariaLabel}>
		{children}
	</Box>;
export const SpinnerContainer = ({
  children,
  testId
}: {
  children: ReactNode;
  testId?: string;
}): React.JSX.Element => <Box testId={testId} xcss={cx(styles.spinnerContainer)}>
		{children}
	</Box>;